import { head, second, wrapArray } from "./array.js";
import { applyTo, identity, pipe } from "./composition.js";
import { filter } from "./filter.js";
import { stack } from "./juxt.js";
import { map } from "./map.js";
import { reduce } from "./reduce.js";
export const wrapObject = (key) => (value) => ({ [key]: value });
export const groupByManyReduce = (keys, reducer, initial) => (it) => {
    const result = {};
    for (const x of it) {
        for (const key of keys(x)) {
            result[key] = reducer(key in result ? result[key] : initial(), x);
        }
    }
    return result;
};
export const count = reduce((counts, element) => {
    counts[element] = (counts[element] || 0) + 1;
    return counts;
}, () => ({}));
export const groupByReduce = (key, reducer, initial) => 
// @ts-expect-error reason: TODO - fix typing
groupByManyReduce(pipe(key, wrapArray), reducer, initial);
export const groupByMany = (keys) => groupByManyReduce(keys, (s, x) => {
    s.push(x);
    return s;
}, () => []);
export const addEntry = (key, value) => (obj) => ({
    ...obj,
    [key]: value,
});
export const groupBy = (f) => 
// @ts-expect-error reason: TODO - fix typing
groupByMany(pipe(f, wrapArray));
export const edgesToGraph = groupByReduce(head, (s, [_, destination]) => {
    s.add(destination);
    return s;
}, () => new Set());
const onEntries = (transformation) => 
// @ts-expect-error: too hard
pipe(Object.entries, 
// @ts-expect-error: too hard
transformation, Object.fromEntries);
export const entryMap = pipe(map, onEntries);
export const entryFilter = pipe(filter, onEntries);
export const valFilter = (f) => 
// @ts-expect-error can't infer typing here
entryFilter(pipe(second, f));
export const keyFilter = (f) => 
// @ts-expect-error can't infer typing here
entryFilter(pipe(head, f));
export const valMap = (f) => 
// @ts-expect-error can't infer typing here
entryMap(stack(identity, f));
export const keyMap = (f) => 
// @ts-expect-error can't infer typing here
entryMap(stack(f, identity));
export const mapTerminals = (terminalMapper) => (obj) => Array.isArray(obj)
    ? map(mapTerminals(terminalMapper))(obj)
    : typeof obj === "object" && !(obj instanceof Function)
        // @ts-expect-error too complicated
        ? valMap(mapTerminals(terminalMapper))(obj)
        : terminalMapper(obj);
export const applySpec = (spec) => (...args) => 
// @ts-expect-error too to bother.
mapTerminals(applyTo(...args))(spec);
